<template>
  <div class="page" v-if="init">
    <h2 v-if="createMode">Создание доктора</h2>
    <h2 v-else>Редактирования доктора</h2>
    <card>
      <form v-on:submit.prevent="onSubmit">
        <div class="vm-form-group">
          <div class="vm-label">
            Сотрудник
          </div>
          <div class="vm-input-field">
            <form-field>
              <b-form-select
                v-model="form.employee"
                :state="!$v.form.employee.$error ? null : false"
                :options="options.employees"
              />
              <error
                v-if="$v.form.employee.$error && !$v.form.employee.required"
              >
                Это поле обязательное
              </error>
            </form-field>
          </div>
        </div>

        <div class="vm-form-group">
          <div class="vm-label">
            Специальность
          </div>
          <div class="vm-input-field">
            <form-field>
              <b-form-select
                v-model="form.specialty"
                :state="!$v.form.specialty.$error ? null : false"
                :options="options.specialties"
              />
              <error
                v-if="$v.form.specialty.$error && !$v.form.specialty.required"
              >
                Это поле обязательное
              </error>
            </form-field>
          </div>
        </div>

        <div class="vm-form-group">
          <div class="vm-label">
            Департамент
          </div>
          <div class="vm-input-field">
            <form-field>
              <b-form-select
                v-model="form.department"
                :state="!$v.form.department.$error ? null : false"
                :options="options.departments"
              />
              <error
                v-if="$v.form.department.$error && !$v.form.department.required"
              >
                Это поле обязательное
              </error>
            </form-field>
          </div>
        </div>

        <div class="vm-form-group">
          <div class="vm-label">
            Квалификация
          </div>
          <div class="vm-input-field">
            <form-field>
              <b-form-input
                v-model="form.degree"
                placeholder="Введите квалификацию..."
              ></b-form-input>
            </form-field>
          </div>
        </div>

        <div class="vm-form-group">
          <div class="vm-label">
            Стаж
          </div>
          <div class="vm-input-field">
            <form-field>
              <b-form-input
                :state="$v.form.experience.numeric ? null : false"
                @blur="$v.form.experience.$touch()"
                v-model="form.experience"
                placeholder="Введите стаж..."
              ></b-form-input>
              <error v-if="!$v.form.experience.numeric">
                Это поле должно быть числом
              </error>
            </form-field>
          </div>
        </div>

        <div class="vm-form-group">
          <div class="vm-label">
            Краткое описание
          </div>
          <div class="vm-input-field">
            <form-field>
              <b-form-textarea
                v-model="form.shortinfo"
                placeholder="Введите краткое описание..."
                rows="3"
              ></b-form-textarea>
            </form-field>
          </div>
        </div>

        <div class="vm-form-group">
          <div class="vm-label">
            Полное описание
          </div>
          <div class="vm-input-field">
            <form-field>
              <b-form-textarea
                v-model="form.fullinfo"
                placeholder="Введите полное описание..."
                rows="6"
              ></b-form-textarea>
            </form-field>
          </div>
        </div>
        <div class="form-group form-group-actions">
          <button
            v-on:click="toList()"
            type="button"
            class="btn btn-outline-primary"
          >
            Отменить
          </button>
          <button type="submit" class="btn btn-primary">
            {{ createMode ? 'Создать' : 'Сохранить' }}
          </button>
        </div>
      </form>
    </card>
  </div>
</template>

<script>
import {
  doctorApi,
  specialtyApi,
  departmentApi,
  employeeApi
} from '../../services';
import Card from '@app/components/uikit/Card';
import FormField from '@app/components/uikit/FormField';
import Error from '@app/components/uikit/Error';
import { required, numeric } from 'vuelidate/lib/validators';

export default {
  components: { Card, FormField, Error },
  data: () => ({
    init: false,
    errors: [],
    createMode: false,
    form: {
      employee: null,
      specialty: null,
      department: null,
      degree: '',
      experience: null,
      shortinfo: '',
      fullinfo: ''
    },
    options: {
      employees: [],
      specialties: [],
      departments: []
    }
  }),
  validations: {
    form: {
      employee: { required },
      specialty: { required },
      department: { required },
      experience: { numeric }
    }
  },
  async created() {
    const loading = this.$loading.show();
    try {
      await this.fetchData();
    } catch (e) {
      console.error(e);
    }
    this.init = true;
    loading.hide();
  },
  watch: {
    $route: 'fetchData'
  },
  methods: {
    async onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      try {
        if (this.createMode) {
          await doctorApi.create(this.form);
        } else {
          const uuid = this.$route.params.id;
          await doctorApi.update(uuid, this.form);
        }
        this.toList();
      } catch (errors) {
        const content = errors.join('\n');
        this.$bvToast.toast(content, {
          title: 'Ошибка',
          autoHideDelay: 10000,
          variant: 'danger'
        });
      }
    },
    toList() {
      this.$router.push({ name: 'registry.doctors' });
    },
    serialize(data) {
      console.log(data);
      return {
        employee: data.employee.id,
        specialty: data.specialty.id,
        department: data.department.id,
        degree: data.degree,
        experience: data.experience,
        shortinfo: data.shortinfo,
        fullinfo: data.fullinfo
      };
    },
    async fetchData() {
      const uuid =
        typeof this.$route.params.uuid === 'undefined'
          ? null
          : this.$route.params.uuid;
      if (uuid === null) {
        this.createMode = true;
      }
      const specialty = specialtyApi.getAll();
      const department = departmentApi.getAll();
      const employee = employeeApi.getAll();
      const doctor = this.createMode
        ? new Promise(resolve =>
            resolve({
              employee: null,
              specialty: null,
              department: null,
              degree: '',
              experience: null,
              shortinfo: '',
              fullinfo: ''
            })
          )
        : doctorApi.get(uuid);

      const result = [
        await (this.createMode ? doctor : this.serialize(await doctor)),
        await specialty,
        await department,
        await employee
      ];
      this.form = result[0];
      this.options.specialties = result[1].items.map(item => {
        const text = item.title;
        const value = item.id;
        return { text, value };
      });
      this.options.departments = result[2].items.map(item => {
        const text = item.title;
        const value = item.id;
        return { text, value };
      });
      this.options.employees = result[3].items.map(item => {
        const text = `${item.firstName} ${item.lastName} ${item.middleName}`;
        const value = item.id;
        return { text, value };
      });
    }
  }
};
</script>

<style scoped>
h2 {
  font-size: 1.5rem;
  color: #727272;
  margin-bottom: 2rem;
}
.vm-form-group {
  display: flex;
  justify-content: center;
}
.vm-label {
  color: #a4a8b0;
  width: 20%;
  margin-top: 0.5rem;
}
.vm-input-field {
  width: 80%;
}
@media (max-width: 700px) {
  .vm-form-group {
    flex-direction: column;
  }
  .vm-label {
    width: 100%;
    margin-bottom: 0.5rem;
  }
  .vm-input-field {
    width: 100%;
  }
}
.form-group-actions {
  margin: 0;
  display: flex;
  justify-content: flex-end;
}
.form-group-actions .btn:first-child {
  margin-right: 6px;
}
.vm-card {
  padding: 2rem;
}
::v-deep .form-group label {
  color: #a3aab2;
}
</style>
